export const ATIVACAO_CONTEXT_N8N_TO_ZENDESK = 'ativacao_context_n8n_to_zendesk';
export const ATIVACAO_CHANGE_DOMAIN_FLOW = 'ativacao_change_domain_flow';
export const ATIVACAO_CHANGE_DOMAIN_BLOCK_MODAL = 'ativacao_change_domain_block_modal';
export const ATIVACAO_SITES_ONBOARDING = 'ativacao_sites_onboarding';
export const ATIVACAO_ONBOARDING_INSIDE_SITES_WIZARD = 'ativacao_onboarding_inside_sites_wizard';
export const ATIVACAO_CHANGE_TEMPORARY_DOMAIN_IN_ONBOARDING = 'ativacao_change_temporary_domain_in_onboarding';
export const ATIVACAO_ALERT_TEMP_DOMAIN = 'ativacao_alert_temp_domain';
export const ATIVACAO_MODAL_REINFORCMENT_CHANGE_DOMAIN_FLOW = 'ativacao_modal_reinforcment_change_domain_flow';
export const ATIVACAO_CHANGEDOMAIN_FAILED_WHOIS = 'ativacao_changedomain_failed_whois';
export const ATIVACAO_CHANGE_SITES_CREATE_BANNER = 'ativacao_change_sites_create_banner';
export const ATIVACAO_ALLOW_CHOOSE_TEMP_OWNED_DOMAIN_ENTRADA = 'ativacao_allow_choose_temp_owned_domain_entrada';
export const ATIVACAO_ALLOW_CHOOSE_TEMP_OWNED_DOMAIN_REENTRADA = 'ativacao_allow_choose_temp_owned_domain_reentrada';
export const ATIVACAO_RESGATE_DOMINIO_GRATUITO = 'ativacao_resgate_dominio_gratuito';
export const ATIVACAO_GET_DNS_FROM_ICANN = 'ativacao_get_dns_from_icann';
export const ATIVACAO_PREVENT_CONTINUE_TO_CHAT_ERROR = 'ativacao_prevent_continue_to_chat_error';
export const ATIVACAO_UPDATE_ONBOARDING_FLOW_EVERY_STEP_CHANGE = 'ativacao_update_onboarding_flow_every_step_change';
export const ATIVACAO_CHOOSE_MIGRATION_STEP = 'ativacao_choose_migration_step';
export const ATIVACAO_WORDPRESS_MIGRATION_FTP = 'ativacao_wordpress_migration_ftp';
export const ATIVACAO_WORDPRESS_MIGRATION_FILES = 'ativacao_wordpress_migration_files';
export const ATIVACAO_WP_MIGRATION_ALERT = 'ativacao_wp_migration_alert';
export const ATIVACAO_BUY_DOMAIN_FLOW = 'ativacao_buy_domain_flow';
export const ATIVACAO_MIGRATE_WP_FILE_MB_SIZE = 'ativacao_migrate_wp_file_mb_size';
export const ATIVACA_MIGRATE_WP_ATTEMPTS = 'ativaca_migrate_wp_attempts';
export const ATIVACAO_MIGRATE_WP_FILE_STORAGE_SIZE = 'ativacao_migrate_wp_file_storage_size';
export const ATIVACAO_SKIP_TICKET_TYPE_SELECTION = 'ativacao_skip_ticket_type_selection';
export const ATIVACAO_REPLACE_WHOIS_WITH_CHECK_DOMAIN_AVAILABLE = 'ativacao_replace_whois_with_check_domain_available';
export const ATIVACAO_N8N_INHOUSE = 'ativacao_n8n_inhouse';
export const ATIVACAO_N8N_INHOUSE_INITIAL_SCREEN = 'ativacao_n8n_inhouse_initial_screen';
export const ATIVACAO_N8N_INHOUSE_URLS = 'ativacao_n8n_inhouse_urls';
export const ATIVACAO_DISABLE_TEXTEAREA_IF_OPTIONS = 'ativacao_disable_textearea_if_options';
export const ATIVACAO_N8N_TIME_TO_RECONNECT = 'ativacao_n8n_time_to_reconnect';
export const ATIVACAO_AICHAT_RATING_THUMBS = 'ativacao_aichat_rating_thumbs';
export const ATIVACAO_AICHAT_RATING_SURVEY = 'ativacao_aichat_rating_survey';
export const ATIVACAO_AICHAT_AUDIO_RECORDING = 'ativacao_aichat_audio_recording';
export const ATIVACAO_ENABLE_ADS_PAGE = 'ativacao_enable_ads_page';
export const ATIVACAO_OPEN_CHAT_ON_LOGIN = 'ativacao_open_chat_on_login';
export const ATIVACAO_NEW_HEADER_AI_CTA = 'ativacao_new_header_ai_cta';
export const ATIVACAO_USE_AI_DEADLINE = 'ativacao_use_ai_deadline';
export const ATIVACAO_ENABLE_AICHAT_GUIDE = 'ativacao_enable_aiChat_guide';
export const ATIVACAO_SUPPORT_HEADER_WITH_AI = 'ativacao_support_header_with_ai';
export const ATIVACAO_USE_TAGS_FROM_AI = 'ativacao_use_tags_from_ai';
export const ATIVACAO_ENABLE_AI_ALERTS = 'ativacao_enable_ai_alerts';

export const CHARLIE_PRECHAT = 'charlie_prechat';
export const CHARLIE_ZENDESK_DELETE_SUNSHINE = 'charlie_zendesk_delete_sunshine';
export const CHARLIE_START_CHAT_MESSAGE = 'charlie_start_chat_message';
export const CHARLIE_CLOUDFLARE_FEATURES = 'charlie_cloudflare_features';
export const CHARLIE_UPGRADE_SITEBUILDER_FORM = 'charlie_upgrade_sitebuilder_form';
export const CHARLIE_PAYMENT_MODAL_V2 = 'charlie_payment_modal_v2';
export const CHARLIE_CHANGE_SUBSCRIPTION_PAYMENT_METHOD = 'charlie_change_subscription_payment_method';
export const CHARLIE_OLD_PAYMENT_MODAL_OPTIONS = 'charlie_old_payment_modal_options';
export const CHARLIE_NEW_PAYMENT_MODAL_OPTIONS = 'charlie_new_payment_modal_options';
export const CHARLIE_CLOUDFLARE_INSIDE_WIZARD_DNS = 'charlie_cloudflare_inside_wizard_dns';
export const CHARLIE_ENABLE_FINANCIAL_CHAT = 'charlie_enable_financial_chat';
export const CHARLIE_ENABLE_GENERAL_CHAT = 'charlie_enable_general_chat';
export const CHARLIE_CLOUDFLARE_TIMERS = 'charlie_cloudflare_timers';
export const CHARLIE_CHAT_HOLIDAYS = 'charlie_chat_holidays';
export const CHARLIE_ALLOW_MULTIAGENT_FOR_MARKETING = 'charlie_allow_multiagent_for_marketing';
export const CHARLIE_MARKETING_WITH_AI_CHAT = 'charlie_marketing_with_ai_chat';

export const XRAY_DIAGNOSTIC_ALERT_CREDIT_CUSTOMER = 'xray_diagnostic_alert_credit_customer';
export const XRAY_VERIFY_CARD_CHECK = 'xray_enable_verifycard_check';
export const XRAY_VERIFY_CARD_LOGS = 'xray_enable_verifycard_logs';
export const XRAY_MANAGEMENT_SIGNATURES_ENABLED_CYCLE_PAYMENT_BUTTON = 'xray_management_signatures_enabled_payment_cycle_button';
export const XRAY_ENABLED_NEW_LAYOUT_INVOICE_PAGE = 'xray_enabled_new_layout_invoice_page';
export const XRAY_ENABLED_VALIDATION_FILTER_WITH_PAGE_NAME = 'xray_enabled_validation_filter_with_page_name';
export const XRAY_MANAGE_REFUND_PAYMENT_CREDITCARD = 'xray_manage_refund_payment_creditcard';
export const XRAY_MANAGE_REFUND_PAYMENT_PAYPAL = 'xray_manage_refund_payment_paypal';
export const XRAY_MANAGE_REFUND_PAYMENT_PIX = 'xray_manage_refund_payment_pix';
export const XRAY_ENABLED_HEADER_INVOICE_PAGE = 'xray_enabled_header_invoice_page';
export const XRAY_PIX_PAYMENT_GATEWAY = 'xray_pix_payment_gateway';
export const XRAY_ENABLED_OPTION_TO_SELECT_PAYPAL_ACCOUNT = 'xray_enabled_option_to_select_paypal_account';
export const XRAY_ENABLED_NEW_TICKET_MODAL = 'xray_enabled_new_ticket_modal';
export const XRAY_ENABLED_BARCODE_DISPLAY = 'xray_enabled_barcode_display';
export const XRAY_ENABLED_SWITCH_PAYMENT_METHOD_BY_PAYPAL = 'xray_enabled_switch_payment_method_by_paypal';
export const XRAY_LIMIT_TIME_IN_SECONDS_TO_DISPLAY_PIX_CODE = 'xray_limit_time_in_seconds_to_display_pix_code';
export const XRAY_ENABLED_REDIRECT_TO_TICKET_MODAL = 'xray_enabled_redirect_to_ticket_modal';
export const XRAY_ENABLED_PAYMENT_METHOD_FILTER = 'xray_enabled_payment_method_filter';
export const XRAY_LIMIT_DATE_TO_DISPLAY_NEW_PIX_LABEL = 'xray_limit_date_to_display_new_pix_label';
export const XRAY_ENABLED_NEW_MESSAGES_IN_SUBSCRIPTION_LIST = 'xray_enabled_new_messages_in_subscription_list';
export const XRAY_ENABLED_PAYMENT_BY_TICKET = 'xray_enabled_payment_by_ticket';
export const XRAY_ENABLED_PAYMENT_BY_CREDIT_CARD = 'xray_enabled_payment_by_credit_card';
export const XRAY_INSTALLMENTS_MODAL = 'xray_installments_modal';
export const XRAY_ENABLED_FINGERPRINT = 'xray_enabled_fingerprint';
export const XRAY_ENABLED_SUBSCRIPTIONS_IN_DIAGNOSTIC = 'xray_enabled_subscriptions_in_diagnostic';
export const XRAY_ENABLED_MODAL_IN_SUBSCRIPTION_MANAGER_BY_URL = 'xray_enabled_modal_in_subscription_manager_by_url';
export const XRAY_ENABLED_DISCOUNT_OFFER_BANNER = 'xray_enabled_discount_offer_banner';
export const XRAY_ENABLED_DISCOUNT_SAVERS = 'xray_enabled_discount_savers';
export const XRAY_LIMIT_DATE_TO_DISPLAY_INVOICE_SPLIT_MESSAGE = 'xray_limit_date_to_display_invoice_split_message';
export const XRAY_LIMIT_DATE_TO_DISPLAY_SPLIT_PAYMENT_BANNER = 'xray_limit_date_to_display_split_payment_banner';
export const XRAY_ENABLED_SPLIT_PAYMENT = 'xray_enabled_split_payment';
export const XRAY_ENABLED_DISCOUNT_RETENTION = 'xray_enabled_discount_retention';
export const XRAY_ENABLED_DISCOUNT_RETENTION_CANCEL_IMMEDIATE = 'xray_enabled_discount_retention_cancel_immediate';
export const XRAY_ENABLED_DISCOUNT_RETENTION_CANCEL_RENEWAL = 'xray_enabled_discount_retention_cancel_renewal';
export const XRAY_RETENTION_OFFER_VERSION_PAGE_AB_TEST = 'xray_retention_offer_version_page_ab_test';
export const XRAY_ENABLED_DISCOUNT_RETENTION_WITH_NEW_BACKEND = 'xray_enabled_discount_retention_with_new_backend';
export const XRAY_CHANGE_PRODUCT_GATEWAY_USER_REQUEST = 'xray_change_product_gateway_user_request';
export const XRAY_ENABLED_WELCOME_CHECKLIST = 'xray_enabled_welcome_checklist';
export const XRAY_ENABLED_RETENTION_OFFER = 'xray_enabled_retention_offer';
export const XRAY_ENABLED_NEW_NFSE_ENDPOINT_CALLING = 'xray_enabled_new_nfse_endpoint_calling';
export const XRAY_ENABLE_CANCELL_WITH_SUPPORT = 'xray_enable_cancel_with_support';
export const XRAY_REQUEST_PAYMENT_METHODS_BY_PRODUCT = 'xray_request_payment_methods_by_product';

export const FOXTROT_WIZARD_WONDERSUITE = 'foxtrot_wizard_wondersuite';
export const FOXTROT_WOOPREMIUM_OFFER = 'foxtrot_woopremium_offer';
export const FOXTROT_FASTCHECKOUT_ADDON = 'foxtrot_fastcheckout_addon';
export const FOXTROT_WIZARD_SITE_EXISTS_CHECK = 'foxtrot_wizard_site_exists_check';
export const FOXTROT_ECOMMERCE_PLUS_CYCLE_CHANGE = 'foxtrot_ecommerce_plus_cycle_change';
export const FOXTROT_ECOMMERCE_PLUS_MODAL_TO_WIZARD = 'foxtrot_ecommerce_plus_modal_to_wizard';
export const FOXTROT_TITAN_ULTRA_SETUP_PAGE = 'foxtrot_titan_ultra_setup_page';
export const FOXTROT_REFUND_TAG = 'foxtrot_refund_tag';
export const FOXTROT_WORDPRESS_IN_WIZARD = 'foxtrot_wordpress_in_wizard';
export const FOXTROT_FASTCHECKOUT_PLG = 'foxtrot_fastcheckout_plg';
export const FOXTROT_HOME_AI_CONVERSATION_BANNER = 'foxtrot_home_ai_conversation_banner';
export const FOXTROT_NEW_AI_CHAT_INTERFACE = 'foxtrot_new_ai_chat_interface';

export const SEND_ZENDESK_TAGS = 'send_zendesk_tags';
export const ZENDESK_WIDGET_KEY = 'zendesk_widget_key';

export const EXPERIENCE_ACCOUNT_SECURITY = 'experience_account_security';
export const EXPERIENCIA_2FA_SMS_METHOD = 'experiencia_2fa_sms_method';
export const EXPERIENCIA_2FA_WHATSAPP_METHOD = 'experiencia_2fa_whatsapp_method';

export const PRE_CHAT_ESTIMATED_TIME_TO_CHAT = 'pre_chat_estimated_time_to_chat';
export const DELETE_ZENDESK_LOCAL_STORAGE = 'delete_zendesk_local_storage';
export const HIDE_CHAT_BUTTON = 'hide_chat_button';
export const MONITOR_CHAT_INACTIVITY = 'monitor_chat_inactivity';
export const ZENDESK_TICKET_ALERT = 'zendesk_ticket_alert';
export const ZENDESK_LOGIN_RETRY = 'zendesk_login_retry';
export const NEW_SUPPORT = 'new_support';
export const ZENDESK_CHAT_FINISH = 'zendesk_chat_finish';
export const ENABLE_SKILLED_DEPARTMENT = 'enable_skilled_department';
export const ASA_TEXTS = 'retention_asa_support_text';
export const CHAT_BOT = 'chat_bot';
export const PROMOTION_BANNER = 'promotion_banner';
export const LIVE_BANNER = 'live_banner';

// PORTIFOLIO
export const ENABLE_LOGO_BUILDER = 'portfolio_logo_builder_feature';
export const ENABLE_SUPPORT_SERVICE_CONTROL = 'enable_support_service_control';
export const ENABLE_STUDIO = 'portfolio_studio_feature';
export const ENABLE_INITIAL_QUESTIONS = 'portfolio_studio_initial_questions';
export const ZENDESK_CHAT_STATUS = 'zendesk_chat_status';
export const PORTFOLIO_HOME_PRO_EMAIL_API = 'portfolio_home_pro_email_api';
export const PORTFOLIO_HG_BUILDER_FEATURE = 'portfolio_hg_builder_feature';
export const PORTFOLIO_VPS_N8N_FEATURE = 'portfolio_vps_n8n_feature';
export const DELETE_NOT_LEGACY_SITES_FEATURE = 'delete_not_legacy_sites_feature';

// AI AGENTS
export const AI_AGENTS_EMAIL_ENABLE_FRONT = 'ai_agents_email_enable_front';
export const AI_AGENTS_MERLIN_EMAIL_CHAT_ID = 'ai_agents_merlin_email_chat_id';
export const AI_AGENTS_MERLIN_DOMAINS_CHAT_ID = 'ai_agents_merlin_domains_chat_id';
export const AI_AGENTS_MERLIN_SITES_CHAT_ID = 'ai_agents_merlin_sites_chat_id';
export const AI_AGENTS_EMAIL_PAGE_BANNER = 'ai_agents_email_page_banner';
export const AI_AGENTS_SITES_PAGE_BANNER = 'ai_agents_sites_page_banner';
export const AI_AGENTS_HOME_PAGE_BANNER = 'ai_agents_home_page_banner';
export const AI_AGENTS_DOMAINS_PAGE = 'ai_agents_domains_page';
export const AI_AGENTS_SITE_BUILDER_AGENT_FACTORY = 'ai_agents_factory_feature';


// DO NOT REMOVE -- SAFETY TOGGLES
export const BRAVO_EMAIL_FLOW = 'bravo_email_flow';
export const BRAVO_CHANGE_PHONE_FLOW = 'bravo_change_phone_flow';

export const CHARLIE_ZENDESK_CHAT_TITLE = 'charlie_zendesk_chat_title';
export const CHARLIE_ZENDESK_SEND_MESSAGE_BUTTON_TITLE = 'charlie_zendesk_send_message_button_title';
export const CHARLIE_ZENDESK_BOT_RESET = 'charlie_zendesk_bot_reset';

// ANALYTICS
export const ENABLE_CONSOLE_LOG_ANALYTICS_EVENTS = 'enable_console_log_analytics_events';
